var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLastStep)?_c('a',{staticClass:"btn btn-success btn-step",attrs:{"id":_vm.myId,"href":_vm.nextRouteHref}},[_c('span',[_vm._v("Continue ")]),_c('i',{staticClass:"fa fa-angle-right"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }